/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsReferences,
    SharedserviceMelcoModelsReferencesFromJSON,
    SharedserviceMelcoModelsReferencesFromJSONTyped,
    SharedserviceMelcoModelsReferencesToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsDesignReferences
 */
export interface SharedserviceMelcoModelsDesignReferences {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsDesignReferences
     */
    custom_product_list?: Array<SharedserviceMelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsDesignReferences
     */
    design_collection_list?: Array<SharedserviceMelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsDesignReferences
     */
    mapping_list?: Array<SharedserviceMelcoModelsReferences> | null;
}

export function SharedserviceMelcoModelsDesignReferencesFromJSON(json: any): SharedserviceMelcoModelsDesignReferences {
    return SharedserviceMelcoModelsDesignReferencesFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsDesignReferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsDesignReferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'custom_product_list': !exists(json, 'custom_product_list') ? undefined : (json['custom_product_list'] === null ? null : (json['custom_product_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
        'design_collection_list': !exists(json, 'design_collection_list') ? undefined : (json['design_collection_list'] === null ? null : (json['design_collection_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
        'mapping_list': !exists(json, 'mapping_list') ? undefined : (json['mapping_list'] === null ? null : (json['mapping_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
    };
}

export function SharedserviceMelcoModelsDesignReferencesToJSON(value?: SharedserviceMelcoModelsDesignReferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'custom_product_list': value.custom_product_list === undefined ? undefined : (value.custom_product_list === null ? null : (value.custom_product_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
        'design_collection_list': value.design_collection_list === undefined ? undefined : (value.design_collection_list === null ? null : (value.design_collection_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
        'mapping_list': value.mapping_list === undefined ? undefined : (value.mapping_list === null ? null : (value.mapping_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
    };
}


